import { buildApiUrl, debugLog } from '../config/environment';

/**
 * POST /password-reset/request
 * Always resolves (200 or 429). Rejects only on network error.
 */
export const requestPasswordReset = async (email) => {
  debugLog('Password reset request for:', email);
  const response = await fetch(buildApiUrl('/password-reset/request'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (response.status === 429) {
    const data = await response.json().catch(() => ({}));
    const err = new Error(data.message || 'Too many requests. Please wait a few minutes.');
    err.status = 429;
    throw err;
  }
  // All other status codes (incl. 500) surface as generic success to prevent enumeration.
  return response.json().catch(() => ({ message: 'Request submitted.' }));
};

/**
 * GET /password-reset/{token}
 * Validates the token and returns { masked_email, expires_at }.
 * Throws with err.status = 410 for expired/used tokens.
 */
export const getPasswordResetSummary = async (token) => {
  const response = await fetch(buildApiUrl(`/password-reset/${encodeURIComponent(token)}`), {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const err = new Error(data.message || 'Invalid or expired reset link.');
    err.status = response.status;
    throw err;
  }
  return response.json();
};

/**
 * POST /password-reset/confirm
 * Submits the new password.
 * Throws with err.status = 400 for weak passwords, 410 for expired/used tokens.
 */
export const confirmPasswordReset = async (token, newPassword) => {
  const response = await fetch(buildApiUrl('/password-reset/confirm'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, new_password: newPassword }),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const err = new Error(data.message || 'Failed to reset password.');
    err.status = response.status;
    throw err;
  }
  return response.json();
};

